import { create } from 'zustand';

export interface OcrSubmission {
  id: string;
  filename: string;
  phase: 'uploading' | 'storing';
  percentage: number | null;
}

interface OcrSubmissionState {
  submission: OcrSubmission | null;
  begin: (filename: string) => string | null;
  updateUpload: (id: string, percentage: number | null) => void;
  finish: (id: string) => void;
}

// Kept outside the page so navigation cannot hide an in-flight submission or
// allow another one before the server has returned its durable job ID.
export const useOcrSubmissionStore = create<OcrSubmissionState>((set, get) => ({
  submission: null,
  begin: (filename) => {
    if (get().submission) return null;
    const id = crypto.randomUUID();
    set({ submission: { id, filename, phase: 'uploading', percentage: null } });
    return id;
  },
  updateUpload: (id, percentage) => set(({ submission }) => {
    if (!submission || submission.id !== id || submission.phase === 'storing') return {};
    const value = percentage == null ? null : Math.max(submission.percentage ?? 0, Math.min(100, percentage));
    return { submission: { ...submission, percentage: value, phase: value === 100 ? 'storing' : 'uploading' } };
  }),
  finish: (id) => {
    if (get().submission?.id === id) set({ submission: null });
  },
}));
